<script lang="ts" setup>
import { MenuItem } from '@headlessui/vue'
</script>

<template>
    <MenuItem
        as="div"
        class="flex cursor-pointer items-center rounded-lg py-2 px-3 text-sm hover:bg-primary-500 hover:text-primary-50 dark:hover:bg-dark-300"
    >
        <slot />
    </MenuItem>
</template>
